<template>
  <div>
    <el-table :data="tableData.slice((page - 1) * pageSize, page * pageSize)" style="width: 90%">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="hero_name" label="英雄"></el-table-column>
      <el-table-column prop="skin_name" label="皮肤"></el-table-column>
      <el-table-column prop="skin_level" label="等级"></el-table-column>
      <el-table-column prop="custom_version" label="版本"></el-table-column>
      <el-table-column v-for="device of deviceList" :key="device" :prop="device" :label="device" #default="{row}">
        <span :class="{'red': row[device] == '不达标', 'green': row[device] == '达标'}">{{ row[device] }}</span>
      </el-table-column>
    </el-table>

    <el-pagination 
      v-model:current-page="page"
      v-model:page-size="pageSize" 
      class="text-end mt-3" 
      size="large" 
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10, 20, 50]"
      :total="total" />
  </div>
</template>

<script>
import {computed, nextTick, ref} from 'vue'
import axios from 'axios'

export default {
  props: {
    project: [String, Number],
    radio_versions: String,
    skinLevel: [String, Number],
    end_date: String,
    start_date: String,
    radio_test: [String, Number],
    hero_skin: [String, Number],
  },

  setup(props) {
    const tableData = ref([]),
      deviceList = ref([]),
      total = ref(0),
      page = ref(1),
      pageSize = ref(10)

    async function getData() {
      await nextTick()
      const {data} = await axios(`report/skin_overview/?project=${props.project}&type=${props.radio_test}&version=${version.value}&start_date=${props.start_date}&end_date=${props.end_date}&action=${action.value}&level=${props.skinLevel}`) 
      
      tableData.value = Object.entries(data.data).map(([id, value]) => {
        return {
          id,
          ...value
        }
      })
      total.value = tableData.value.length
      deviceList.value = data.device_list
    }

    const action = computed(() => props.radio_test == 4 ? "" : props.hero_skin)
    const version = computed(() => props.radio_versions === '全版本' ? '' : props.radio_versions)

    return {pageSize, total, page, deviceList, tableData, getData}
  }
}
</script>

<style scoped>
.el-table:before {
  display: none;
}

.el-table :deep(th), 
.el-table :deep(tr),
.el-table :deep(td),
.el-table :deep(tr:hover),
.el-table :deep(tr:hover td) {
  color: #fff;
  background-color: rgb(34, 37, 41);
  border-bottom: 1px solid #606469;
}

.el-table :deep(tr:hover td) {
  color: #4ed8da;
}

.green {
  color: #00b050;
}

.red {
  color: #dc143c;
}
</style>